import IconArrowBack from '@/components/icons/arrowBack.vue'
   import IconBase from '@/components/IconBase.vue'
   import IconForwardBack from '@/components/icons/arrowForward.vue'
   import IconCheck from '@/components/icons/check.vue'
   import Globals from '@/assets/scripts/global-functions.js'
   import BackButton from '@/components/BackButton.vue'
   import NextButton from '@/components/forms/ButtonNext.vue'

   export default {
      $_veeValidate: {
         validator: 'new'
      },
       name: "EducatorPayment",
       components: {
           IconArrowBack,
           IconBase,
           IconCheck,
           IconForwardBack,
           BackButton,
           NextButton
       },
       data: () => ({
          
       }),
       computed: {
         AllFieldsValid: function() {
            let _isvalid = false;
            
            return _isvalid;
         }
       },
       methods: {
           ValidateExistingData() {
               if(localStorage.getItem(this.$parent.ReturnProcess()) != undefined || localStorage.getItem(this.$parent.ReturnProcess()) != null || localStorage.getItem(this.$parent.ReturnProcess()) != "") {
                  this.$parent[this.$parent.ReturnProcess()] = JSON.parse(localStorage.getItem(this.$parent.ReturnProcess()));
               }
           },
           ProcessPayment() {
              window.location="/educator/confirmation"
           }
       },
       mounted () {
         this.ValidateExistingData();
       }
   }